import '@common/styles/tooltip.css';

import { copyTextToClipboard } from '@common/utils';
import { context } from '@common/utils/constants';
import { ReactComponent as Close } from '@images/Close.svg';
import { ReactComponent as Copy } from '@images/Copy.svg';
import { ReactComponent as DoubleChecks } from '@images/DoubleChecks.svg';
import { ReactComponent as EmailIcon } from '@images/Email.svg';
import { ReactComponent as FacebookIcon } from '@images/Facebook.svg';
import { ReactComponent as ShareIcon } from '@images/Share.svg';
import { ReactComponent as TwitterIcon } from '@images/Twitter.svg';
import { ReactComponent as WhatsappShare } from '@images/Whatsapp.svg';
// import TwitterFooter from '@images/Twitter.svg';
// import Image from '@lib/Image';
import Modal from '@lib/Modal';
import React, { useState } from 'react';

const ShareModal: React.FunctionComponent<WishlistProps> = ({ product }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCopyToClipboardShown, setIsCopyToClipboardShown] = useState(false);

  const facebookURL = `https://www.facebook.com/dialog/feed?app_id=${context.FACEBOOK_APP_ID}&link=${product?.fullURL}&picture=${product?.images[0]}&name=${product?.title}&caption=${product?.shortDescription}&description=${product?.description}&redirect_uri=http://www.facebook.com`;
  const tweetContent = `Check out ${product?.title} at`;
  const twitterURL = `https://twitter.com/intent/tweet?text=${tweetContent}&url=${product?.fullURL}`;
  const mailSubject = `Check out ${product?.title}`;
  const mailBody = `Check out ${product?.title} at ${product?.fullURL}`;
  const mailURL = `mailto:?subject=${mailSubject}&body=${mailBody}`;
  const whatsappContent = `Check out ${product?.title} at ${product?.fullURL}`;
  const whatsappURL = `https://web.whatsapp.com/send?text=${whatsappContent}`;

  return (
    <>
      <ShareIcon onClick={() => setIsOpen(true)} className="inline-block cursor-pointer" />
      {isOpen ? (
        <Modal
          className="w-360 px-24 py-16"
          noPadding
          closeModal={() => {
            setIsOpen(false);
          }}
        >
          <div className="flex">
            <div
              className="text-heading text-18 font-medium mb-32"
              color-customisation="page-body-text"
              font-customisation="para-text"
            >
              Share this product
            </div>
            <div
              onClick={() => {
                setIsOpen(false);
                setIsCopyToClipboardShown(false);
              }}
              className="flex-1 cursor-pointer flex justify-end"
            >
              <Close className="h-24 w-24" />
            </div>
          </div>
          <div>
            <a href={facebookURL} className="flex justify-start items-center mb-16">
              <FacebookIcon className="" alt="facebook_icon" />
              <p className="ml-12 text-heading text-16 font-normal">Facebook</p>
            </a>
            <a href={twitterURL} className="flex justify-start items-center  mb-16">
              <TwitterIcon className="" alt="facebook_icon" />
              <p className="ml-12 text-heading text-16 font-normal">Twitter</p>
            </a>
            <a href={mailURL} className="flex justify-start items-center h-24 mb-16">
              <EmailIcon className="inline-block" width={24} height={24} alt="email_icon" />
              <p className="ml-12 text-heading text-16 font-normal">Email</p>
            </a>
            <a href={whatsappURL} className="flex justify-start items-center h-24 mb-16">
              <WhatsappShare className="inline-block m-4" alt="whatsapp_icon" />
              <p className="ml-12 text-heading text-16 font-normal">Whatsapp</p>
            </a>
            <div className="h-2 w-full bg-beige mb-16"></div>
            <p className="text-heading pb-8">Product Link</p>
            <div className="flex bg-beige p-8 items-center">
              <p className="text-heading flex-1 break-all">{product.shortLink || product.fullURL}</p>
              <div className="flex justify-end">
                {!isCopyToClipboardShown ? (
                  <Copy
                    onClick={() => {
                      copyTextToClipboard(product.shortLink || product.fullURL);
                      setIsCopyToClipboardShown(true);
                    }}
                    className="inline-block cursor-pointer ml-12"
                  />
                ) : (
                  <DoubleChecks className="inline-block ml-12" />
                )}
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default ShareModal;
